module.exports = __webpack_public_path__ + "img/ev_header.edba2be8.png";